export const districtUsageIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#schoolFilter',
    intro: 'Select a school from the dropdown to view WordFlight usage data for that school.',
  },
  {
    element: '#printButton',
    intro: 'Click here to print the WordFlight System Usage report for the selected school(s).'
  },
  {
    element: '.dashboard-header-bar',
    intro: 'Usage Detail is where you can view WordFlight System usage data. You can see WordFlight System enrollment, usage trends, weekly time goals, and more.'
  },
  {
    element: '#district-report-school-guidance',
    intro: 'See the school guidance for tips on how to use this report.',
  },
  {
    element: '#district-report-usage-trend',
    intro: 'See the graph which shows the average minutes per week trend across the school year for the district.',
  },
  {
    element: '#enrollment-numbers',
    intro: 'See the number of students enrolled in the WordFlight System.'
  },
  {
    element: '#loginDateRange',
    intro: 'Select a date range from the dropdown to view WordFlight System usage data for that week.'
  },
  {
    element: '#school-engagement',
    intro: 'See the number of schools that had 70% of students hit their minimum weekly time goal for the selected date range.',
  },
  {
    element: '#teacher-engagement',
    intro: 'See the number of teachers that had 70% of students hit the weekly time goal for the selected date range.',
  },
  {
    element: '#weeklyTimeGoal',
    intro: 'See the average weekly usage in minutes, the minimum weekly usage goal in minutes, and the distribution of student usage within the selected date range.'
  },
];
